import { faqs } from "../data/faqs";

export const getFaqs = id => {

    return faqs.filter( module => faqs.id === id );

}